module.exports = __webpack_public_path__ + "img/planning2.5ea7e64a.svg";